import React from "react"
import "../css/interest.css"

export default function About()
{
    return (
        <div className="interest">
            <h2>interest</h2>
            <p>Music scholar. Internet fanatic. Infotainment Geek. Programming worm. Hardcore Gamer. Pop culture ninja. </p>
        </div>
    )
}